(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("topojson", [], factory);
	else if(typeof exports === 'object')
		exports["topojson"] = factory();
	else
		root["topojson"] = factory();
})(self, function() {
return 